import axios from "axios";
import baseUrl from "../utils/baseUrl";

/**
 * Instancia global de Axios con configuración base
 * Incluye interceptores para manejo automático de autenticación y errores
 */
const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * Interceptor de Request
 * Agrega automáticamente el token de autenticación a todas las peticiones
 */
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Interceptor de Response
 * Maneja errores globales como tokens inválidos
 */
axiosInstance.interceptors.response.use(
  (response) => {
    // Si la respuesta contiene "Token invalid", limpiar localStorage
    if (response.data?.msg === "Token invalid") {
      localStorage.clear();
      window.location.href = "/";
      return Promise.reject(new Error("Token invalid"));
    }
    return response;
  },
  (error) => {
    // Manejo de errores 401 (No autorizado)
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
